import React from 'react';
import './PlayerArea.css';

interface PlayerAreaProps {
  className?: string;
  children?: React.ReactNode;
  placeholder?: string;
  label?: string;
}

export const PlayerArea: React.FC<PlayerAreaProps> = ({
  className = "",
  children,
  placeholder = "NOMBRE DEL JUGADOR",
  label = "Nombre del jugador"
}) => {
  return (
    <div className={`player-area ${className}`}>
      <div className="cam-container">
        <input
          type="text"
          placeholder={placeholder}
          defaultValue=""
          aria-label={label}
        />
        <div className="border-betis"></div>
      </div>
      <div>
        {children}
      </div>
    </div>
  );
};
